module.exports = __webpack_public_path__ + "img/ep-0-9-dosis.a45e6b30.jpg";